var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @flow
import React, { Component } from 'react';
import { palette } from '@shared/utils/styled';
import { FormattedMessage, injectIntl } from 'react-intl';
import localStore from 'store';
import SessionLayout from 'templates/SessionLayout';
import { BackButtonSmall } from '@shared/molecules/BackButtonSmall';
import history from '@store/history';
import SubMenu from 'organisms/SubMenu';
import TabMenu from 'molecules/TabMenu';
import messages from './messages';
var Category = /** @class */ (function (_super) {
    __extends(Category, _super);
    function Category(props) {
        var _this = _super.call(this, props) || this;
        _this.mafId = localStore.get('mafId');
        _this.getTabs = function () {
            var _a = _this.props, primaryCategories = _a.primaryCategories, session = _a.session;
            return primaryCategories.reduce(function (acc, item) {
                acc.push({
                    title: item.displayName,
                    target: "/" + session.uuid + "/search/" + item.id,
                    id: item.id,
                });
                return acc;
            }, []);
        };
        return _this;
    }
    Category.prototype.render = function () {
        var _a = this.props, deleteWatchlistItem = _a.deleteWatchlistItem, intl = _a.intl, session = _a.session, watchlist = _a.watchlist;
        var tabs = this.getTabs();
        return (_jsxs(SessionLayout, __assign({ backgroundColor: palette('white'), deleteWatchlistItem: deleteWatchlistItem, session: session, watchlist: watchlist, subMenu: _jsx(SubMenu, { cancelIcon: _jsx(BackButtonSmall, { action: function () { return history.push('/'); }, fill: 'white', withText: true }, void 0), title: intl.formatMessage(messages.title) }, void 0) }, { children: [this.mafId && (_jsx("p", __assign({ style: { padding: '0px 5px' } }, { children: _jsx(FormattedMessage, { defaultMessage: '-', id: 'matchandfit.notice' }, void 0) }), void 0)), _jsx("div", { children: _jsx(TabMenu, { tabs: tabs }, void 0) }, void 0)] }), void 0));
    };
    return Category;
}(Component));
export default injectIntl(Category);
